const navbar = {
  packages: "חבילות", // translated
  hotelPackages: "חבילות מלון", // translated
  experiences: "חוויות", // translated
  close: "סגור", // translated
  hotDeals: "עסקאות חמות", // translated
  dashboard: "לוּחַ מַחווָנִים", // translated
  pricing: "תמחור", // translated
};

export default navbar;
